import qs from 'qs'

/**
 * Generate a payment link for an event
 * @returns
 */
export function generateEventTicketPaymentLink({
  eventId,
  privateLinkId,
}: {
  eventId: MaybeRefOrGetter<string>
  privateLinkId: MaybeRefOrGetter<string | undefined>
}) {
  const {
    public: { appLink },
  } = useRuntimeConfig()

  const query = qs.stringify(
    {
      target: 'event-ticket',
      eventId: toValue(eventId),
      key: toValue(privateLinkId),
    },
    {
      skipNulls: true,
      addQueryPrefix: true,
    }
  )

  return `${appLink}/payments${query}`
}

/**
 * Generate event app link
 * @returns
 */
export function generateEventAppLink({
  eventId,
  //privateLinkId,
}: {
  eventId: MaybeRefOrGetter<string>
  //privateLinkId?: MaybeRefOrGetter<string | undefined>
}) {
  const {
    public: { appLink },
  } = useRuntimeConfig()

  return `${appLink}/activities/${toValue(eventId)}`
}
